import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export type AppLocale =
  'sl' | 'en' | 'de' | 'hr' | 'it' | 'fr' | 'pl' | 'et' | 'es' | 'cs' | 'fi' | 'hu' | 'da';

export const supportedLocales: AppLocale[] = [
  'sl',
  'en',
  'de',
  'hr',
  'it',
  'fr',
  'pl',
  'et',
  'es',
  'cs',
  'fi',
  'hu',
  'da',
];

export const appEnv = createEnv({
  /**
   * To avoid Zod type mismatches and ensure that default values are used
   * correctly, we recommend setting this option to true.
   */
  emptyStringAsUndefined: true,
  /**
   * The prefix that client-side variables must have. This is enforced both at
   * a type-level and at runtime.
   */
  clientPrefix: 'VITE_',
  server: {
    /*
     * ENVs which will not be exposed to client.
     * Example:
     * SECRET_KEY: z.string().min(1),
     */
  },
  client: {
    /*
     * ENVs which will be exposed to client. These need VITE_ prefix.
     * Example:
     * VITE_PUBLISHABLE_KEY: z.string().min(1),
     */
    VITE_APP_URL: z.string().url(),
    VITE_API_URL: z.string().url(),
    VITE_PORTAL_URL: z.string().url(),
    VITE_PUBLIC_SENTRY_DSN: z.string().min(1),
    VITE_ASSETS_URL: z.string().url(),
  },
  runtimeEnv: import.meta.env,
});

interface AppConfig {
  fallbackLanguage: AppLocale;
  supportedLocales: AppLocale[];
}

export const appConfig: AppConfig = {
  fallbackLanguage: 'en',
  supportedLocales,
};
